import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Info = (props) => (
  <SvgIcon {...props}>
    <path d="M12,2.22857143 C17.3828571,2.22857143 21.7714286,6.61714286 21.7714286,12 C21.7714286,17.3828571 17.3828571,21.7714286 12,21.7714286 C6.6073024,21.7619925 2.23800749,17.3926976 2.22857143,12 C2.22857143,6.61714286 6.61714286,2.22857143 12,2.22857143 Z M12,0 C5.38285714,0 0,5.38285714 0,12 C0,18.6171429 5.38285714,24 12,24 C18.6171429,24 24,18.6171429 24,12 C24,5.38285714 18.6171429,0 12,0 Z M13.7142857,5.14285714 L10.2857143,5.14285714 L10.2857143,13.7142857 L13.7142857,13.7142857 L13.7142857,5.14285714 Z M13.7142857,15.4285714 L10.2857143,15.4285714 L10.2857143,18.8571429 L13.7142857,18.8571429 L13.7142857,15.4285714 Z" />
  </SvgIcon>
);

export default Info;
